// Sale Terms follow who assessed the Lot. A Vendor Assessed Lot carries its own
// standard terms; an Agent Assessed one keeps the terms off the Seller's
// profile, the way it has always worked.
export const VENDOR_ASSESSED = 'Vendor Assessed'

export const VENDOR_ASSESSED_SALE_TERMS =
  '7 business days approved buyers. All others cash before delivery.'

/*
 The Sale Terms the assessment form fills in for the assessor type the Seller
 picked. The Seller can still type their own over the top - `current` is only
 replaced while it is one of the two the form put there itself.

 assessorType       - the value of the 'assessorType' dropdown
 current            - the Sale Terms on the draft Lot right now
 agentAssessedTerms - the Seller's own terms, off their profile
 */
export function saleTermsForAssessorType (assessorType, { current = '', agentAssessedTerms = '' } = {}) {
  let isSellersOwnText = Boolean(current) &&
    current !== VENDOR_ASSESSED_SALE_TERMS &&
    current !== agentAssessedTerms
  if (isSellersOwnText) {
    return current
  }
  return assessorType === VENDOR_ASSESSED ? VENDOR_ASSESSED_SALE_TERMS : agentAssessedTerms
}
